import { render, staticRenderFns } from "./updateout.vue?vue&type=template&id=18c152e0&scoped=true"
import script from "./updateout.vue?vue&type=script&lang=js"
export * from "./updateout.vue?vue&type=script&lang=js"
import style0 from "./updateout.vue?vue&type=style&index=0&id=18c152e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c152e0",
  null
  
)

export default component.exports